export default "__VITE_ASSET__CTDIB5cF__"